import React, { useEffect, useRef, useState } from 'react'
import './customization.view.css';
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import {
    ButtonAddHLPure,
    ButtonHLPure,
    CheckBoxHLPure,
    DataPickerHLPure,
    DialogSystemGLPure,
    DropDownBtnHLPure,
    GridSelectionHLPure,
    HeaderHLPure,
    InputHLPure,
    PromotionalFooterPure,
    SimpleLoading,
    TooltipHLPure,
    Traslates,
    PanelBarGLPure,
    InputSwitchHLPure
} from '../../pures';
import { TrashIcon, arrowDropDown } from '../../../assets/logos/icons';
import { Link } from 'react-router-dom';

const NumberInputWithButtons = ({ value, onChange, disabled, placeholder }) => {
    const MIN_VALUE = 1
    const MAX_VALUE = 30

    const handleIncrement = () => {
        const currentValue = value || 10
        const newValue = Math.min(currentValue + 1, MAX_VALUE)
        onChange({ target: { value: newValue } })
    }

    const handleDecrement = () => {
        const currentValue = value || 10
        const newValue = Math.max(currentValue - 1, MIN_VALUE)
        onChange({ target: { value: newValue } })
    }

    const handleInputChange = (e) => {
        let newValue = parseInt(e.target.value, 10)

        // If empty or NaN, set to default
        if (!newValue || isNaN(newValue)) {
            newValue = 10
        }

        // Clamp value between MIN and MAX
        newValue = Math.max(MIN_VALUE, Math.min(newValue, MAX_VALUE))

        onChange({ target: { value: newValue } })
    }

    return (
        <div className='customizationView-number-input-container'>
            <InputHLPure
                inputActive
                disabled={disabled}
                typeInput="number"
                valueInput={value || 10}
                handleChangeInput={handleInputChange}
                placeholder={placeholder}
            />
            {!disabled && (
                <>
                    <button
                        className='customizationView-number-btn customizationView-number-btn-decrement'
                        onClick={handleDecrement}
                        disabled={(value || 10) <= MIN_VALUE}
                        type="button"
                        aria-label='Decrementar'
                    >
                        <i className="k-icon k-i-minus"></i>
                    </button>
                    <button
                        className='customizationView-number-btn customizationView-number-btn-increment'
                        onClick={handleIncrement}
                        disabled={(value || 10) >= MAX_VALUE}
                        type="button"
                        aria-label='Incrementar'
                    >
                        <i className="k-icon k-i-plus"></i>
                    </button>
                </>
            )}
        </div>
    )
}

const ImgInput = ({
    imageFile,
    imageUrl,
    label,
    fileType,
    onImageUpload,
    onImageDelete,
    imageName,

    tooltipShow, //True or false to show tooltip
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description optional
    restContent, //More text to tooltip description optional
    informationIcon, // Choose the information icon true or false to custom img
}) => {
    const imageRef = useRef(null)
    const uploadFile = (ref) => ref.current.click();

    const deleteImageHandler = () => {
        imageRef.current.value = "";
        onImageDelete(imageName);
    }

    const src = imageFile || imageUrl;

    return (
        <div className='ImgInput'>
            <div className='ImgInput-image-container' onClick={() => uploadFile(imageRef)}>
                {src != "" &&
                    <img
                        className="ImgInput-image"
                        src={src}
                    />
                }
            </div>
            <div className='ImgInput-actions'>
                <ButtonAddHLPure
                    nameBtn={label}
                    onClickBtn={() => uploadFile(imageRef)}
                    iconAdd
                />
                {tooltipShow &&
                    <TooltipHLPure
                        positionTooltip={positionTooltip ? positionTooltip : "right"}
                        titleTooltip={titleTooltip}
                        descriptionTooltip={descriptionTooltip}
                        subContent={subContent}
                        restContent={restContent}
                        informationIcon={informationIcon}
                    />
                }
                {
                    imageFile &&
                    <img
                        src={TrashIcon}
                        alt="Elimina la imagen"
                        onClick={deleteImageHandler}
                        className='ImgInput-icon-trash'
                    />
                }
            </div>

            <input
                ref={imageRef}
                onChange={(e) => onImageUpload(e, imageName)}
                type='file'
                id='fileKey'
                accept={fileType}
                className='ImgInput-hidden-input'
            />
        </div>
    )
}


const CustomizationView = (props) => {
    const { updatedPreferences, setPreferences, modifiedByUser, modifiedDate, groups, setGroups, companies } = props;
    const { t } = useTranslation();
    const fileRef = useRef();

    const cellColumnOne = (props) => {
        return (
            <td className='customizationView-cell-one'>
                <div className='customizationView-cell-one-container'>
                    <span className="gridHLPure-userName">
                        {props.dataItem.preferenceName}
                    </span>
                    <span className="gridHLPure-fieldSubtitle">
                        {props.dataItem.help || ""}
                    </span>
                </div>
            </td>
        );
    }

    /**
     *
     *
     * @param {React.ChangeEvent<HTMLInputElement>} e
     * @param {*} preference
     */
    const setExtraData = (e, preference) => {
        const preferenceFound = updatedPreferences.find(preferenceOld => preferenceOld.id === preference.id)
        preferenceFound.extraData["companyId"] = e.target.value
    }

    const cellColumnTwo = (props) => {
        const { dataItem } = props;
        const inputType = dataItem.type;
        const isDisabled = !dataItem.booleanValue;
        const focus = dataItem.focus ? true : false
        let value = "";
        let optionsDropDown = []

        if (dataItem.booleanValue || dataItem.preferenceName === t('customizationView.preferences.name.nameProcessignDocumentsForEntityExtractionWithAI')) {
            if (inputType === 'string') value = dataItem.stringValue || ''
            if (inputType === 'number') {
                value = dataItem.numberValue || 0;
                // Set default value for session inactivity timeout
                if (dataItem.preferenceName === t('customizationView.preferences.name.nameSessionInactivityTimeoutMinutes') && (!dataItem.numberValue || dataItem.numberValue === 0)) {
                    value = Number(process.env.REACT_APP_PREFERENCE_SESSION_INACTIVITY_TIMEOUT_DEFAULT_VALUE)
                }
            }
            if (inputType === "date") value = (dataItem.dateValue) ? new Date(dataItem.dateValue) : new Date();
            if (inputType === "file") {
                value = dataItem.stringValue;
                if (value) {
                    if (typeof value === "string" && value !== "") {
                        const filename = value.split('/').pop()
                        value = filename
                    } else {
                        value = dataItem.stringValue.name;
                    }
                }
            }

            if (inputType === "selector") {
                value = dataItem.stringValue || process.env.REACT_APP_OPTIONS_SEND_DOCUMENT_TO_OCR_ON_DEMAND
                optionsDropDown = dataItem.configRule.map(configRule => {
                    let data = {
                        name: configRule.name,
                        key: configRule.key
                    }

                    return data
                })
            }

            if (inputType === "custom_file") {
                value = dataItem.stringValue;
                if (value) {
                    if (typeof value === "string" && value !== "") {
                        const filename = value.split('/').pop()
                        value = filename
                    } else {
                        value = dataItem.stringValue.name;
                    }
                }
            }
        }
        let showSwitch = true
        if (
            [
                process.env.REACT_APP_PREFERENCE_PORCENTUAL_OTP,
                process.env.REACT_APP_PREFERENCE_WEEKS_QUANTITY_OTP
            ].includes(dataItem.preferenceName)) showSwitch = false

        return (
            <td className='customizationView-cell-two'>
                <div className='customizationView-cell-two-container'>
                    <div className={`customizationView-input-wrapper ${inputType}`}>
                        {inputType === "string" && (
                            <InputHLPure
                                inputActive
                                disabled={isDisabled}
                                typeInput={inputType}
                                valueInput={value}
                                handleChangeInput={(e) => handleChangInputs(e, props.dataItem)}
                                autoFocus={focus}
                            />
                        )
                        }
                        {inputType === 'number' && dataItem.preferenceName === t('customizationView.preferences.name.nameSessionInactivityTimeoutMinutes') && (
                            <NumberInputWithButtons
                                value={value || 10}
                                onChange={(e) => handleChangInputs(e, props.dataItem)}
                                disabled={isDisabled}
                                placeholder={dataItem.customValue}
                            />
                        )
                        }
                        {inputType === 'number' && dataItem.preferenceName !== t('customizationView.preferences.name.nameSessionInactivityTimeoutMinutes') && (
                            <InputHLPure
                                inputActive
                                disabled={isDisabled}
                                typeInput={inputType}
                                valueInput={value}
                                handleChangeInput={(e) => handleChangInputs(e, props.dataItem)}
                                placeholder={dataItem.customValue}
                                autoFocus={focus}
                            />
                        )
                        }
                        {inputType === "date" && (
                            <Traslates>
                                <DataPickerHLPure
                                    valueDate={value}
                                    handleChangeDate={(e) => handleChangInputs(e, props.dataItem)}
                                    disabled={isDisabled}
                                />
                            </Traslates>
                        )
                        }
                        {inputType === 'file' && (
                            <div className='customizationView-input-file-type'>
                                <InputHLPure
                                    inputActive
                                    disabled
                                    typeInput="text"
                                    valueInput={value}
                                />
                                {
                                    !isDisabled &&
                                    <>
                                        <button
                                            className='customizationView-input-file-upload'
                                            aria-label='Cargar imagen'
                                            onClick={() => fileRef.current.click()}
                                            disabled={isDisabled}
                                        >
                                            <i className="k-icon k-i-plus"></i>
                                        </button>
                                        <input
                                            ref={fileRef}
                                            disabled={isDisabled}
                                            id={props.dataItem.id}
                                            type="file"
                                            className="customizationView-input-file"
                                            // accept=".png"
                                            onChange={(e) => handleChangInputs(e, props.dataItem)}
                                        />
                                    </>
                                }
                            </div>
                        )
                        }
                        {inputType === 'selector' && (
                            <DropDownBtnHLPure
                                labelDropDown={''}
                                optionsDropDown={optionsDropDown}
                                optionsValue={value || t("customizationView.preferences.options.userChoose")}
                                valueItem={'key'}
                                nameOption={"name"}
                                onDropDownChange={(e) => handleChangInputs(e, props.dataItem)}
                                disable={false}
                            />
                        )
                        }
                        {inputType === "custom_file" &&
                            <div className='customizationView-input-custom-file-type'>
                                {!isDisabled &&
                                    <>
                                        <DropDownBtnHLPure
                                            labelDropDown="Empresa"
                                            optionsDropDown={companies}
                                            optionsValue={optionsDropDown[0]}
                                            valueItem="id"
                                            nameOption="companyName"
                                            onDropDownChange={(e) => setExtraData(e, props.dataItem)}
                                        />
                                        <InputHLPure
                                            inputActive
                                            disabled
                                            typeInput="text"
                                            valueInput={value}
                                        />
                                        <button
                                            className='customizationView-input-file-upload'
                                            aria-label='Cargar archivo'
                                            onClick={() => fileRef.current.click()}
                                            disabled={isDisabled}
                                        >
                                            <i className="k-icon k-i-plus"></i>
                                        </button>
                                        <input
                                            ref={fileRef}
                                            disabled={isDisabled}
                                            id={props.dataItem.id}
                                            type="file"
                                            accept='docx'
                                            className="customizationView-input-file"
                                            onChange={(e) => handleChangInputs(e, props.dataItem)}
                                        />
                                    </>
                                }
                                <div className='customizationView-switch'>
                                    <InputSwitchHLPure
                                        customClass="contractGenerated-logic-switch-display"
                                        checked={props.dataItem.booleanValue}
                                        onChange={(e) => onItemChange(e, props.dataItem)}
                                    />
                                </div>
                            </div>
                        }
                    </div>
                    {!showSwitch || (props.dataItem.type !== 'selector' && props.dataItem.type !== 'custom_file') && (
                        <div className='customizationView-switch'>
                            <InputSwitchHLPure
                                customClass="contractGenerated-logic-switch-display"
                                checked={props.dataItem.booleanValue}
                                onChange={(e) => onItemChange(e, props.dataItem)}
                            />
                        </div>
                    )
                    }
                </div>
            </td >
        );
    };


    const onClickSave = () => props.onSavePreferences();

    /**
     * @param {React.ChangeEvent<HTMLInputElement>} e
     * @param {object} preference
     */
    const extraDataChange = (e, preference) => {

    }

    const onItemChange = (event, preference) => {
        let value = event.target.value
        //Update preferences
        const editedItemID = preference.preferenceId;
        const data = updatedPreferences.map(item => {
            if (item.preferenceId === editedItemID) {
                let updatedItem = { ...item, ['booleanValue']: value }
                if (!value) {
                    // borrar input si se deselecciona el checkbox
                    updatedItem.stringValue = "";
                    updatedItem.dateValue = "";
                    // Keep default value of 10 for session inactivity timeout
                    if (preference.preferenceName === t('customizationView.preferences.name.nameSessionInactivityTimeoutMinutes')) {
                        updatedItem.numberValue = Number(process.env.REACT_APP_PREFERENCE_SESSION_INACTIVITY_TIMEOUT_DEFAULT_VALUE)
                    } else {
                        updatedItem.numberValue = ''
                    }
                } else {
                    // When activating the switch, ensure session inactivity has default value
                    if (preference.preferenceName === t('customizationView.preferences.name.nameSessionInactivityTimeoutMinutes') && (!updatedItem.numberValue || updatedItem.numberValue === "" || updatedItem.numberValue === 0)) {
                        updatedItem.numberValue = Number(process.env.REACT_APP_PREFERENCE_SESSION_INACTIVITY_TIMEOUT_DEFAULT_VALUE)
                    }
                }
                return updatedItem;
            }
            return item;
        });

        switch (preference.preferenceName) {
            case process.env.REACT_APP_PREFERENCE_PORCENTUAL_OTP:
                const weeksQuantity = groups.find(group => group.group === t("customizationView.preferences.title.security")).preferences.find(preference => preference.preferenceName === process.env.REACT_APP_PREFERENCE_WEEKS_QUANTITY_OTP)
                if (weeksQuantity.booleanValue) {
                    weeksQuantity.booleanValue = false
                    weeksQuantity.numberValue = ""

                }
                break;
            case process.env.REACT_APP_PREFERENCE_WEEKS_QUANTITY_OTP:
                const porcentual = groups.find(group => group.group === t("customizationView.preferences.title.security")).preferences.find(preference => preference.preferenceName === process.env.REACT_APP_PREFERENCE_PORCENTUAL_OTP)
                if (porcentual.booleanValue) {
                    porcentual.booleanValue = false
                    porcentual.numberValue = ""
                }
                break;
        }

        //Update groups
        let groupsString = JSON.stringify(groups)
        let copyGroups = JSON.parse(groupsString)
        let newGroups = copyGroups.map((group) => {
            group.preferences.map((preferenceGroup) => {
                if (preferenceGroup.preferenceId === preference.preferenceId) {
                    preferenceGroup.booleanValue = value
                    if (!value) {
                        preferenceGroup.stringValue = "";
                        preferenceGroup.dateValue = "";
                        // Keep default value of 10 for session inactivity timeout
                        if (preference.preferenceName === t('customizationView.preferences.name.nameSessionInactivityTimeoutMinutes')) {
                            preferenceGroup.numberValue = Number(process.env.REACT_APP_PREFERENCE_SESSION_INACTIVITY_TIMEOUT_DEFAULT_VALUE)
                        } else {
                            preferenceGroup.numberValue = "";
                        }
                    } else {
                        // When activating the switch, ensure session inactivity has default value
                        if (preference.preferenceName === t('customizationView.preferences.name.nameSessionInactivityTimeoutMinutes') && (!preferenceGroup.numberValue || preferenceGroup.numberValue === "" || preferenceGroup.numberValue === 0)) {
                            preferenceGroup.numberValue = Number(process.env.REACT_APP_PREFERENCE_SESSION_INACTIVITY_TIMEOUT_DEFAULT_VALUE)
                        }
                    }
                    preferenceGroup.focus = true
                } else {
                    preferenceGroup.focus = false
                }
                return preferenceGroup
            })

            return group
        })


        setGroups(newGroups)
        setPreferences(data);
    };

    const header = (props) => {
        return <span>{props.title}</span>;
    };

    const handleChangInputs = (e, preference) => {
        let value = e.target.value;
        let preferencesString = JSON.stringify(updatedPreferences)
        let copyPreferences = JSON.parse(preferencesString)
        let newPreferences = copyPreferences.map((updatePreference) => {
            if (preference.preferenceId === updatePreference.preferenceId) {
                if (updatePreference.type === "string") updatePreference.stringValue = value || ""
                if (updatePreference.type === "number") {

                    updatePreference.numberValue = +value || 0;

                    if (updatePreference.preferenceName === process.env.REACT_APP_PREFERENCE_PORCENTUAL_OTP) {
                        value = Math.floor(value)
                        if (value >= +process.env.REACT_APP_PREFERENCE_PORCENTUAL_OTP_MIN_VALUE && value <= +process.env.REACT_APP_PREFERENCE_PORCENTUAL_OTP_MAX_VALUE) updatePreference.numberValue = value
                        else updatePreference.numberValue = 0
                    } else if (updatePreference.preferenceName === process.env.REACT_APP_PREFERENCE_WEEKS_QUANTITY_OTP) {
                        value = Math.floor(value)
                        if (value >= +process.env.REACT_APP_PREFERENCE_WEEKS_QUANTITY_OTP_MIN_VALUE && value <= +process.env.REACT_APP_PREFERENCE_WEEKS_QUANTITY_OTP_MAX_VALUE) updatePreference.numberValue = value
                        else updatePreference.numberValue = 0
                    }
                }
                if (updatePreference.type === "date") updatePreference.dateValue = value || new Date()
                if (updatePreference.type === "file") updatePreference.stringValue = e.target.files[0] || ""
                if (updatePreference.type === "selector") updatePreference.stringValue = value || ""
                if (updatePreference.type === "custom_file") {
                    updatePreference.stringValue = e.target.files[0] || ""
                }
            }
            return updatePreference
        })

        let groupsString = JSON.stringify(groups)
        let copyGroups = JSON.parse(groupsString)
        let newGroups = copyGroups.map((group) => {
            group.preferences.map((preferenceGroup) => {
                if (preference.preferenceId === preferenceGroup.preferenceId) {
                    if (preferenceGroup.type === "string") preferenceGroup.stringValue = value || ""
                    if (preferenceGroup.type === "number") {
                        preferenceGroup.numberValue = +value || 0;
                        if (preferenceGroup.preferenceName === process.env.REACT_APP_PREFERENCE_PORCENTUAL_OTP) {
                            value = Math.floor(value)
                            if (value >= 0 && value <= 100) preferenceGroup.numberValue = value
                            else preferenceGroup.numberValue = 0
                        }

                        if (preferenceGroup.preferenceName === process.env.REACT_APP_PREFERENCE_WEEKS_QUANTITY_OTP) {
                            value = Math.floor(value)
                            if (value >= 1 && value <= 12) preferenceGroup.numberValue = value
                            else preferenceGroup.numberValue = 0
                        }
                    }
                    if (preferenceGroup.type === "date") preferenceGroup.dateValue = value || new Date()
                    if (preferenceGroup.type === "file") preferenceGroup.stringValue = e.target.files[0] || ""
                    if (preferenceGroup.type === "selector") preferenceGroup.stringValue = value || ""
                    if (preferenceGroup.type === "custom_file") {
                        preferenceGroup.stringValue = e.target.files[0] || ""
                    }
                    preferenceGroup.focus = true
                } else {
                    preferenceGroup.focus = false
                }
                return preferenceGroup
            })

            return group
        })

        setGroups(newGroups)
        setPreferences(newPreferences);
    };

    if (props.isLoading) return <div className='standard-wrapper'>
        <SimpleLoading />
    </div>

    return (
        <>
            <div className='standard-wrapper'>
                <Container>
                    <HeaderHLPure title={t("customizationView.labels.title")} />

                    <Grid item xs={12}>
                        <div className='customizationView-client-logo-input'>
                            <ImgInput
                                imageFile={props.clientLogo?.base64}
                                imageUrl={props.clientLogoUrl}
                                imageName="clientLogo"
                                label={t("customizationView.labels.upload.logo")}
                                fileType={t("reliableSignatureIdentificationDocuments.fileType")}
                                onImageUpload={props.onImageUpload}
                                onImageDelete={props.onImageDelete}

                                tooltipShow
                                informationIcon
                                titleTooltip={t("customizationView.labels.upload.logo.company")}
                                descriptionTooltip={"Al cargar el logo de tu empresa en la plataforma, este se visualizará en la parte superior de las pantallas."}
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12} className='customizationView-item-container'>
                        <p className='customizationView-list-title'>{t("customizationView.labels.customization")}</p>
                        {
                            groups.map((group) => (
                                <div className='customizationView-panels'>
                                    <PanelBarGLPure
                                        expandedPanel={true}
                                        titlePanel={group.group}
                                        id={"customizationView-panel"}
                                    >
                                        <div className='customizationView-grid-documents'>
                                            <GridSelectionHLPure
                                                dataGrid={group.preferences}
                                                styleGeneral={true}
                                                skip={0}
                                                take={group.preferences.length}
                                                pageable={false}
                                                styleGeneralClass={"customizationView-general-grid"}

                                                titleRow1={""}
                                                headerColumnOne={header}
                                                cellColumnOne={cellColumnOne}

                                                columnTwo={true}
                                                titleRow2={""}
                                                headerColumnTwo={header}
                                                cellColumnTwo={cellColumnTwo}

                                                styleGrid={{ height: 'auto' }}
                                            />
                                        </div>
                                    </PanelBarGLPure>
                                </div>
                            ))
                        }
                    </Grid>

                    <Grid item xs={12}>
                        <div className='customizationView-item-container'>
                            {modifiedByUser && modifiedDate &&
                                <p className='customizationView-modified-by'>{t("customizationView.labels.modify", { modifiedByUser, modifiedDate })}</p>
                            }
                            <div className='customizationView-actions'>
                                <Link to='/configuration'>
                                    <ButtonHLPure
                                        nameBtn={t("customizationView.btns.exit")}
                                        onClickBtn={() => { }}
                                    />
                                </Link>
                                <ButtonHLPure
                                    primary
                                    nameBtn={t("customizationView.btns.save")}
                                    onClickBtn={onClickSave}
                                />
                            </div>
                        </div>
                    </Grid>

                    <PromotionalFooterPure />
                </Container>
            </div>
            <DialogSystemGLPure
                showLoadingRequesting={props.showLoadingRequesting}
                toggleLoadingRequesting={props.toggleLoadingRequesting}

                showCompletedRequesting={props.showCompletedRequesting}
                toggleCompletedRequesting={props.toggleCompletedRequesting}

                showWarningRequesting={props.showWarningRequesting}
                toggleWarningRequesting={props.toggleWarningRequesting}

                showErrorRequesting={props.showErrorRequesting}
                toggleErrorRequesting={props.toggleErrorRequesting}
                message={props.messageError}
            />
        </>
    )
}

export default CustomizationView;